import Vue from 'vue'
import { js_beautify as jsBeautify } from 'js-beautify'

// Might want to change it to UUID
const indexBy = 'id'

// Layout mutations
const mutations = {
  // Normalize data and save all layouts to store
  SET (state, request) {
    // Map layout [indexBy] to be key
    var newArr = {}
    request.data.forEach(layout => {
      newArr[layout[indexBy]] = layout
    })
    state.layouts = newArr
    state.currentPage = parseInt(request.headers['x-pagination-current-page'])
    state.totalPageCount = parseInt(request.headers['x-pagination-page-count'])
  },

  // Add new layout to store
  ADD (state, layout) {
    Vue.set(state.layouts, layout[indexBy], layout)
  },

  // Remove layout from store
  REMOVE (state, key) {
    Vue.delete(state.layouts, key)
  },

  UPDATE (state, layout) {
    Vue.set(state.layouts, layout[indexBy], layout)
  },

  // Make layout active
  SET_ACTIVE (state, key = null) {
    state.active = state.layouts[key]
  },

  SET_NEW (state, layoutId) {
    state.newLayout = {
      ...state.layouts[layoutId],
      json: jsBeautify(
        JSON.stringify(state.layouts[layoutId].json),
        {
          indent_size: 2
        }
      )
    }
  },

  UPDATE_NEW ({ newLayout }, { key, value }) {
    newLayout[key] = value
  },

  CLEAR_NEW ({ newLayout }) {
    Object.keys(newLayout).forEach(key => {
      newLayout[key] = ''
    })
  },

  SET_PER_PAGE (state, perPage) {
    state.perPage = perPage
  },

  SET_REVISIONS (state, request) {
    state.revisions = request.data
    state.currentPage = parseInt(request.headers['x-pagination-current-page'])
    state.totalPageCount = parseInt(request.headers['x-pagination-page-count'])
    state.totalCount = parseInt(request.headers['x-pagination-total-count'])

    if (state.currentPage === 1 && request.data.length) {
      state.shortRevisionList = request.data.slice(0, 5)
    }
  },

  CLEAR_REVISIONS (state) {
    state.revisions = []
    state.currentPage = 1
    state.totalPageCount = 1
    state.totalCount = 0
  },

  SELECT_REVISION (state, { json, id }) {
    state.activeRevisionId = id

    state.newLayout = {
      ...state.newLayout,
      id: state.newLayout.id,
      json: jsBeautify(
        JSON.stringify(json),
        { indent_size: 2 }
      )
    }
  }
}

export default mutations
